export const fetchingDelayTime = 1200; // ms
